<template lang="html">
  <div id="rightbar" class="rightbar darkBackground hidden-xs">
    <div class="rightbar__icons--app">
      <ul class="rightbar__icons">
        <li
          class="rightbar__icons--item"
          v-for="(item, key, index) in appLinks"
          v-if="item.active==1"
          >
          <a
            :href="item.url"
            :target="item.target"
            :title="item.title"
            @click.prevent="redirector(item.url, item.target)"
            >
            <img
              :src="$getImagePath('images', 'icon_'+item.icon+'.svg')"
              :alt="item.type"
              class="rightbar__img"
              >
          </a>
        </li>
      </ul>
    </div>

    <div class="rightbar__icons--socialmedia">
      <ul class="rightbar__icons">
        <li
          class="rightbar__icons--item"
          v-for="(item, key, index) in socialLinks"
          v-if="item.active==1"
          >
          <a
            :title="item.title"
            @click.preven="redirector(item.url, item.target)"
            >
            <img
              :src="$getImagePath('images', 'icon_'+item.type+'.svg')"
              :alt="item.type"
              class="rightbar__img"
              >
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Rightbar',
    data() {
      return {
        appLinks: this.$root.StaticData.links,
        socialLinks: this.$root.StaticData.sociallinks
      }
    },
    methods: {
      redirector (url, target) {
        let vm = this
        let host = window.location.origin
        if (url === '/#/downloads!') {
          url = `${host}${url}`
        }

        let urlTest = url.includes('http')

        // console.log('host: ', host)
        // console.log('redirector: ', url, target)

        // Redirect to the requested page
        if (!urlTest) {
          // console.log('urlTest: ', url)
          let newUrl = `${url}`
          // console.log('newUrl: ', newUrl)
          vm.$router.push({ path: `${newUrl}` })
          vm.$forceUpdate()
        } else {
          window.open(url, target).focus()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/includes/Rightbar.vue